export default __webpack_public_path__ + "static/media/NIFRSHFSVv2220426NIFRSHFSVReferralPathwayv2_flowchart.71bf26a7.jpg";